import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { CommonService, SiteService } from 'src/app/services/index';
import { AlertService, WarningDialog } from 'src/app/shared/index';
@Component({
  selector: 'app-manage-solar-scheduler',
  templateUrl: './manage-solar-scheduler.component.html',
  styleUrls: ['./manage-solar-scheduler.component.scss']
})
export class ManageSolarSchedulerComponent implements OnInit {
  siteId: string;
  selectedSite: string;
  sites: any;
  exportDataForm: UntypedFormGroup;
  displayAllSiteID: boolean;
  date = new UntypedFormControl(new Date());
  startView = 'month';
  max = new Date();
  constructor(
    private siteService: SiteService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private alertService: AlertService
  ) {
    this.exportDataForm = this.fb.group({
      siteCtr: ['', [Validators.required]]
      // dateCtr: []
    });
  }

  ngOnInit() {
    this.getSiteDetails();
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.displayAllSiteID = false;
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.displayAllSiteID = true;
    }
  }
  getSiteDetails() {
    this.siteService.getSiteDetails().subscribe((data) => {
      this.sites = data;
    });
  }
  addMissingSolarValues() {
    const seft = this;
    const date = moment(this.date.value).format('YYYY-MM-DD');
    if (localStorage.getItem('isMultipleSites') === 'false') {
      this.selectedSite = localStorage.getItem('siteId');
    } else {
      this.selectedSite = this.siteId;
    }
    const params = {
      siteID: this.selectedSite,
      Date: date
    };

    this.siteService.insertSolarData(params).subscribe(function (data) {
      if (!seft.commonService.isNullOrUndefined(data)) {
        seft.showMessage(data.message, 'Bosch-Ic-information');
      }
    });
  }
  showMessage(msg, newIconClass) {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = msg;
    dialogRef.componentInstance.newIconClass = newIconClass;

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }
}
